var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-page-content-wrapper company" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.company"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("settings.companySubtitles"))),
      ]),
    ]),
    _vm._v(" "),
    _c("section", [
      _c("div", { staticClass: "fields" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.organizationName")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.errors.first("companyName")
                      ? "error"
                      : "success",
                    "has-feedback.": "",
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { placeholder: "Company Name", name: "companyName" },
                    model: {
                      value: _vm.organizationName,
                      callback: function ($$v) {
                        _vm.organizationName = $$v
                      },
                      expression: "organizationName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.companySlogan")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.errors.first("companySlogan")
                      ? "error"
                      : "success",
                    "has-feedback.": "",
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      placeholder: "Organization Long Name",
                      name: "companyName",
                    },
                    model: {
                      value: _vm.companySlogan,
                      callback: function ($$v) {
                        _vm.companySlogan = $$v
                      },
                      expression: "companySlogan",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("chatbotv2.chatbotName")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.errors.first("chatbotName")
                      ? "error"
                      : "success",
                    "has-feedback.": "",
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { placeholder: "Chatbot Adı", name: "chatbotName" },
                    model: {
                      value: _vm.chatbotName,
                      callback: function ($$v) {
                        _vm.chatbotName = $$v
                      },
                      expression: "chatbotName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.organizationLogo")))]),
          _vm._v(" "),
          _c("div", { staticClass: "input-wrapper" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: _vm.tippyOptions,
                    expression: "tippyOptions",
                  },
                ],
                staticClass: "image-box",
                class: { empty: !_vm.logoUrl },
                attrs: { content: _vm.$t("message.vtipyUploadLogo") },
                on: { click: _vm.openSelectImage },
              },
              [
                !_vm.logoUrl
                  ? _c("EmptyImage", { staticClass: "empty" })
                  : _vm._e(),
                _vm._v(" "),
                _c("AddImageIcon", { staticClass: "upload-image" }),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: _vm.uploading
                      ? "/static/loader-animated.svg"
                      : _vm.logoUrl,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("chatbotv2.chatbotLogo")))]),
          _vm._v(" "),
          _c("div", { staticClass: "input-wrapper" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: _vm.tippyOptions,
                    expression: "tippyOptions",
                  },
                ],
                staticClass: "image-box",
                class: { empty: !_vm.chatbotAvatarUrl },
                attrs: { content: "Chatbot Resmi" },
                on: { click: _vm.openSelectImageChatbotAvatar },
              },
              [
                !_vm.chatbotAvatarUrl
                  ? _c("EmptyImage", { staticClass: "empty" })
                  : _vm._e(),
                _vm._v(" "),
                _c("AddImageIcon", { staticClass: "upload-image" }),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: _vm.chatbotUploading
                      ? "/static/loader-animated.svg"
                      : _vm.chatbotAvatarUrl,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }